<div class="contact-container">
  <div class="modal-body modal-content">
    <div class="logo-container mb-2">
      <img
        *ngIf="primaryLogo"
        [class]="secondaryLogo ? 'header-logo ' : 'header-logo-large'"
        [src]="primaryLogo"
        [alt]="primaryLogoAltText"
      />
      <img *ngIf="secondaryLogo" [src]="secondaryLogo" class="header-logo" [alt]="secondaryLogoAltText" />
    </div>
    <div class="Spa_Style_Primary_Color" [innerHTML]="customText | safe : 'html'"></div>
    <div *ngIf="locationSectionEnabled" class="row">
      <div class="col-12 d-flex flex-column justify-content-between">
        <div class="no-translate-block">
          <h3 class="Spa_Style_H4 pt-3 m-0" [innerHTML]="locationTitle | safe : 'html'"></h3>
          <div class="Spa_Style_Paragraph" [innerHTML]="address | safe : 'html'"></div>
        </div>
        <div class="no-translate-block">
          <div
            class="Spa_Style_Primary_Color Spa_Style_Regular_Font Spa_Style_Bold_Weight pt-2"
            [innerHTML]="phoneTitle | safe : 'html'"
          ></div>
          <div class="Spa_Style_Paragraph">
            <div [innerHTML]="phoneNumber | safe : 'html'"></div>
            <div [innerHTML]="hours | safe : 'html'"></div>
          </div>
          <div [innerHTML]="email | safe : 'html'"></div>
        </div>
      </div>
    </div>
  </div>
</div>
